export class Cap {
    id: number;
    cap: string;
    itemName: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/cap.ts